// extracted by mini-css-extract-plugin
export default {"groupTitle":"index_groupTitle__eDlMV","left":"index_left__Pv3Ol"};